import React from 'react'; 
import { Container, Row, Col } from "react-bootstrap";
import ContactImg from "../assets/img/astronaut-waving-both-hand.svg";
import Whatsapp from "../assets/img/whatsapp-icon.svg";
import Gmail from "../assets/img/gmail-icon.svg";
import Fiverr from "../assets/img/fiverr.svg";
import Facebook from "../assets/img/facebook-icon.svg";
import Instagram from "../assets/img/instagram-icon.svg";
import Linkedin from "../assets/img/linkedin-icon.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import Popup from 'reactjs-popup';


export const Contact = () => {
    
  return (
    <section className="contact" id="contact">
      <Container>
        <h2>Contact Me</h2>
        <Row className="align-items-center">

        <Col xs={11} md={5} xl={5}>
          <TrackVisibility>
            {({ isVisible }) =>
              <div className="about-img">
              <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={ContactImg} alt="Contact Us"/>
              </div>
            }
          </TrackVisibility>
        </Col>

        <Col xs={12} md={7} xl={6}>
          <TrackVisibility>
            {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <Row className="about-icons">
                  <Col xs={3} md={3} xl={3} className='icon-text'>
                    <Popup 
                      trigger={<img src={Gmail} alt='gmail'/>}
                      position="top left">
                        <div>mayurapriyadarshana11@gmail.com</div>
                    </Popup>
                    <p>Gmail</p>
                  </Col>
                  <Col xs={3} md={3} xl={3} className='icon-text'>
                  <a href="https://wa.me/+94754936597"><img src={Whatsapp} alt='whatsapp'/></a>
                    <p>Whatsapp</p>
                  </Col>
                  <Col xs={3} md={3} xl={3} className='icon-text'>
                  <a href="https://www.facebook.com/profile.php?id=100004363098980&mibextid=ZbWKwL"><img src={Facebook} alt='facebook'/></a>
                    <p>Facebook</p>
                  </Col>
                  <Col xs={3} md={3} xl={3} className='icon-text'>
                  <a href="https://instagram.com/mayura_priyadarshana?utm_source=qr&igshid=MzNlNGNkZWQ4Mg=="><img src={Instagram} alt='instagram'/></a>
                    <p>Instagram</p>
                  </Col>
                  <Col xs={3} md={3} xl={3} className='icon-text'>
                  <a href="https://www.fiverr.com/mayura9"><img src={Fiverr} alt='linkedin'/></a>
                    <p>Fiverr</p>
                  </Col>
                  <Col xs={3} md={3} xl={3} className='icon-text'>
                  <a href="https://www.linkedin.com/in/mayura-priyadarshana-3b16a5247"><img src={Linkedin} alt='linkedin'/></a>
                    <p>Linkedin</p>
                  </Col>
                </Row>
              </div>}
          </TrackVisibility>
        </Col>

        </Row>
      </Container>
    </section>
  )
}
